// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__WBaH_","ranges":"BmiRanges_ranges__ZPwDP"};